import axiosInstance from '../../../../../../utils/axios';
import { LoginResponse, TwoFactorMethod } from './interfaces';
import { User } from './models';
import { decodeJWT } from '../../utils/decodedJWT';
import { handleAuthError } from './errors';
import { CustomApiResponse } from '../../../../../../utils/apiResponse';

export const loginUser = async (
  email: string,
  password: string,
  remember: boolean,
  method?: TwoFactorMethod,
  code?: string
): Promise<CustomApiResponse<any>> => {
  const payload: User = { type: 'default', email, password, method, code };

  try {
    // 1. Call the API
    const response = await axiosInstance.post<CustomApiResponse<any>>(
      `/users/login`,
      payload
    );

    const apiResponse = response.data;
    
    // 2. UNPACKING LOGIC (Fix for ResponseEntity serialization)
    // We work on a copy of the data to handle cases where it is nested in 'body'
    let responseData = apiResponse.data;

    if (responseData && typeof responseData === 'object' && 'body' in responseData) {
      // If the backend returned the ResponseEntity object inside data
      responseData = responseData.body;
    }

    /**
     * CASE 1: DIRECT LOGIN SUCCESS
     * We check if the unpacked data contains an accessToken.
     */
    if (apiResponse.status === 'success' && responseData?.accessToken) {
      const tokens = responseData as LoginResponse;
      const decoded = decodeJWT(tokens.accessToken);

      if (!decoded) {
        throw new Error('Failed to decode the JWT.');
      }

      // Return the structure expected by AuthContext
      return {
        ...apiResponse,
        data: { tokens, user: decoded }
      };
    }

    /**
     * CASE 2: 2FA REQUIRED
     * If it's a success but no token, it must be the list of methods.
     * We return the unpacked data (which is the array of methods).
     */
    return {
        ...apiResponse,
        data: responseData
    };

  } catch (error: any) {
    if (error?.response) {
      handleAuthError(error);
    }
    throw error;
  }
};
